import React from "react";

const Separator = ({ height }) => {
  const line_height = height ? height.toString() : "1";
  return <div style={{ height: line_height + "em" }} />;
};

export default Separator;
